<template>
	<div class="opts_wrap" v-loading="loading">
		<div class="opts_line">
			<p class="txt">价格公式：</p>
			<div class="con">
				<p class="t">原价格 x</p>
				<el-input class="w80 ml8" v-model="coefficient"></el-input>
				<el-select class="w80 ml8" v-model="type">
					<el-option label="+" :value="1">+</el-option>
					<el-option label="-" :value="2">-</el-option>
				</el-select>
				<el-input class="w80 ml8" v-model="money"></el-input>
				<p class="t ml8">元</p>
			</div>
		</div>
		<div class="opts_line">
			<p class="txt">分角设置：</p>
			<div class="con">
				<el-radio-group v-model="radio_type">
					<el-radio :label="item.type" v-for="(item,index) in fenjiao" :key="index">{{item.name}}</el-radio>
				</el-radio-group>
			</div>
		</div>
		<div class="opts_line" style="display: none;">
			<p class="txt">一口价设置：</p>
			<div class="con">
				<el-radio-group v-model="radio_price">
					<el-radio :label="item.type" v-for="(item,index) in price" :key="index">{{item.name}}</el-radio>
				</el-radio-group>
			</div>
		</div>
		<div class="btn_wrap">
			<p class="btn" @click="saveBtn()">提交</p>
			<p class="btn" @click="reset()">重置</p>
			<p class="btn" @click="cancel()">取消</p>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
export default {
	name: "pricePloy",
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			coefficient:"1.00",
			money:"0.00",
			type:1,
			fenjiao:[
				{name:'保留分角',type:1},
				{name:'抹去分',type:2},
				{name:'抹去分角',type:3},
				],
			price:[],
			radio_type:1,
			radio_price:1,
			is_save:false,
			cl_id:"",
			loading: false
		};
	},
	
	created(){
	},
	mounted() {
		this.init()
	},
	
	computed:{
		...mapState({
			
		}),
	},
	watch:{
		show(val) {
			if(val){
				this.init()
			}
		}
	},
	
	methods: {
		...mapActions({
		}),
		init(){
			this.loading = false
			this.reset()
		},
		saveBtn(){
			let ployData = {
				id:this.cl_id,
				coefficient:this.coefficient,
				type:this.type,
				money:this.money,
				set_fenjiao:this.radio_type,
				set_price:this.radio_price
			}
			this.loading = true
			this.$emit('submit',ployData)
		},
		
		reset(){
			this.coefficient = "1.00"
			this.money = "0.00"
			this.type = 1
			this.radio_type = 1
			this.radio_price = 1
		},
		cancel(){
			this.$emit('close', {})
		}
	},

}
</script>

<style scoped>
	.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line{margin-top: 30px;display: flex;align-items: center;}
	.opts_line .txt{width: 90px;text-align: right;font-size: 14px;}
	.opts_line .con{flex: 1;width: 0;margin-left: 22px;display: flex;align-items: center;}
	.opts_line .con .t{font-size: 14px;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.opts_wrap .btn_wrap .btn:nth-child(3){background: #fff;color: #333;border: 1px solid #ddd;}
	.w80{width: 80px;}
	
	
	.el-input--suffix .el-input__inner{padding: 0 0 0 12px !important;font-size: 16px;}
	/*red border color*/
	.el-input__inner:focus ,.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus ,.el-radio__input.is-checked .el-radio__inner ,.el-radio__inner:hover{border-color: var(--red);}
	
	/*red color*/
	.el-select-dropdown__item.selected ,.el-radio__input.is-checked+.el-radio__label{color: var(--red);}
	
	/*red background color*/
	.el-radio__input.is-checked .el-radio__inner{background-color: var(--red);}
</style>
